import './MainBlock.css';

function MainBlock(props) {
    return (
        <div style={{
            ...props.style
        }}>
            <div className="container">
                <div className="car">
                    <img src="/Car.png" style={{
                        maxWidth: "70%",
                        width: "auto",
                        objectFit: "contain"
                    }}/>
                </div>
                <div className="message">
                    <img src="/Message.png" style={{
                        maxWidth: "90%",
                        height: "auto",
                        width: "auto",
                        objectFit: "contain"
                    }}/>
                </div>
                <div className="buttons">
                    <a href="https://www.fiverr.com/s/KeG8QNz">
                        <img src="/Button2.png" style={{
                            height: "auto",
                            width: "100%",
                            objectFit: "contain"
                        }}/>
                    </a>
                    <a href="https://t.me/Kirilll2002">
                        <img src="/Button.png" style={{
                            height: "auto",
                            width: "100%",
                            objectFit: "contain"
                        }}/>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default MainBlock;